module.exports = __webpack_public_path__ + "img/part-2-title.1af5d994.png";